import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Store, Zap } from 'lucide-react';

export default function ServicesTabs({ active }) {
  const { language } = useLanguage();
  const tr = (lv, en, ru) => (language === 'lv' ? lv : language === 'ru' ? ru : en);

  const base = 'inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all';
  const activeCls = 'bg-[#D97736] text-white shadow-sm';
  const idle = 'bg-white text-[#5C5C5C] border border-[#E5E4E0] hover:border-[#D97736] hover:text-[#D97736]';

  return (
    <div className="flex flex-wrap gap-2" data-testid="services-tabs">
      <Link
        to="/gigs"
        className={`${base} ${active === 'gigs' ? activeCls : idle}`}
        data-testid="services-tab-gigs"
      >
        <Zap className="w-4 h-4" /> {tr('Haltūras', 'Gigs', 'Халтуры')}
      </Link>
      <Link
        to="/listings?category=service"
        className={`${base} ${active === 'providers' ? activeCls : idle}`}
        data-testid="services-tab-providers"
      >
        <Store className="w-4 h-4" /> {tr('Pakalpojumu sniedzēji', 'Service providers', 'Поставщики услуг')}
      </Link>
    </div>
  );
}
